export type DeleteTeamErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class DeleteTeamError extends Error {
    code: DeleteTeamErrorCode;
    constructor(code: DeleteTeamErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
